import {initWebComponent} from "@/helpers/web-component-helper";
import {initPopper} from "@/modules/popper";
import {HeaderHomeComponent} from "@/components/layout/buttons/header-home-component";
import {HeaderLayerComponent} from "@/components/layout/buttons/header-layer-component";
import {HeaderDividerComponent} from "@/components/layout/buttons/header-divider-component";
import {HeaderDataPortalComponent} from "@/components/layout/buttons/header-data-portal-component";
import {HeaderSearchComponent} from "@/components/layout/buttons/header-search-component";
import {HeaderLogoComponent} from "@/components/layout/buttons/header-logo-component";
import {HeaderInfoComponent} from "@/components/layout/buttons/header-info-component";
import {HeaderButtonComponent} from "@/components/layout/buttons/header-button-component";
import {HeaderLoginComponent} from "@/components/layout/buttons/header-login-component";
import {HeaderShareComponent} from "@/components/layout/buttons/header-share-component";
import {HeaderPrintComponent} from "@/components/layout/buttons/header-print-component";
import {HeaderFullScreenComponent} from "@/components/layout/buttons/header-full-screen-component";
import {HeaderLanguageComponent} from "@/components/layout/buttons/header-language-component";
import {HeaderRightMouseButtonComponent} from "@/components/layout/buttons/header-right-mouse-button-component";
import {HeaderLogoutComponent} from "@/components/layout/buttons/header-logout-component";
import {HeaderNotificationsComponent} from "@/components/layout/buttons/header-notifications-component";
import {HeaderFilterComponent} from "@/components/layout/buttons/header-filter-component";
import {HeaderFilterItemComponent} from "@/components/layout/buttons/header-filter-item-component";
import {HeaderSettingsComponent} from "@/components/layout/buttons/header-settings-component";

const template = document.createElement('template');
template.innerHTML = `<nav class="layout-navbar pt-0 pb-0 navbar navbar-expand align-items-center bg-navbar-theme">
  <div class="navbar-collapse collapse" id="layout-navbar-collapse">
    <div class="navbar-nav align-items-lg-center w-100">
      <header-layer class="divMyLayers d-none"></header-layer>
      <header-divider class="divReloadPage d-none" data-height="33"></header-divider>
      <header-home class="divReloadPage d-none"></header-home>
      <header-divider class="divReloadPage d-none" data-height="33"></header-divider>
      <header-search class="zoekvenster d-none"></header-search>
      <header-divider class="divReloadPage d-none" data-height="33"></header-divider>
      <header-filter style="display:none" class="zoekvenster d-none"></header-filter>
      <header-logo class="w-100"></header-logo>
    </div>
    <div class="navbar-nav align-items-lg-center">
      <header-right-mouse-button class="divMenuRechtermuisbutton d-none"></header-right-mouse-button>
      <header-divider class="divMenuRechtermuisbutton d-none" data-height="33"></header-divider>
      <header-print class="divMenuPDF d-none"></header-print>
      <header-divider class="divMenuPDF d-none" data-height="33"></header-divider>
      <header-notifications class="divShowAnnouncements d-none"></header-notifications>
      <header-divider class="divShowAnnouncements d-none" data-height="33""></header-divider>
      <header-login class="d-none divProfileMenu"></header-login>
      <header-logout class="d-none divProfileMenu"></header-logout>
      <header-divider class="divProfileMenu d-none" data-height="33"></header-divider>
      <header-info class="divMenuHelp d-none"></header-info>
      <header-divider class="divMenuHelp d-none" data-height="33"></header-divider>
      <header-full-screen class="divFullScreen d-none"></header-full-screen>
<!--      <header-settings class="d-none"></header-settings>-->
       <!-- / language -->
    </div>
  </div>
</nav>  
<div class="row swipe d-none">
    <div class="col-12">
        <input id="swipe" type="range" style="width: 100%">
    </div>
</div>
`;

export class LayoutHeaderComponent extends HTMLElement{
    constructor(){
        super();
        initWebComponent(this, template)

        initPopper()
    }
}

window.customElements.define("header-home", HeaderHomeComponent);
window.customElements.define("header-layer", HeaderLayerComponent);
window.customElements.define("header-data-portal", HeaderDataPortalComponent);
window.customElements.define("header-divider", HeaderDividerComponent);
window.customElements.define("header-search", HeaderSearchComponent);
window.customElements.define("header-logo", HeaderLogoComponent);
window.customElements.define("header-right-mouse-button", HeaderRightMouseButtonComponent);
window.customElements.define("header-info", HeaderInfoComponent);
window.customElements.define("header-login", HeaderLoginComponent);
window.customElements.define("header-logout", HeaderLogoutComponent);
window.customElements.define("header-share", HeaderShareComponent);
window.customElements.define("header-print", HeaderPrintComponent);
window.customElements.define("header-full-screen", HeaderFullScreenComponent);
window.customElements.define("header-language", HeaderLanguageComponent);
window.customElements.define("header-notifications", HeaderNotificationsComponent);
window.customElements.define("header-filter", HeaderFilterComponent);
window.customElements.define("header-filter-item", HeaderFilterItemComponent);
window.customElements.define("header-settings", HeaderSettingsComponent);

window.customElements.define("header-button", HeaderButtonComponent);
